<script lang="ts" setup></script>

<template>
    <div class="the-loading"></div>
</template>

<style lang="scss">
.the-loading {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;

    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    background-color: rgba(0, 0, 0, 0.5);

    z-index: 100;
}
</style>
